module.exports = __webpack_public_path__ + "img/searchFail.82fe6fea.png";